/**
 * Email benchmark, 13 Oct 2026 (round 2): who sent an outgoing message. The person who sent as the mailbox, or the person who sent
 * it from BlockGenie, is named; a message sent as a shared mailbox with no person recorded says so, never naming the mailbox as one.
 */
export function sentByNote(message:{direction?:string;sent_by_name?:string|null;sender_not_recorded?:boolean},author:string|false|undefined){
 if(author)return ` · Sent by ${author}`;
 if(message.direction!=='Outbound')return '';
 if(message.sent_by_name)return ` · Sent by ${message.sent_by_name}`;
 return message.sender_not_recorded?' · sender not recorded':'';
}
